var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"tab-content px-4 pt-0 pb-4"},[_c('search-box',{ref:"childRefBox",on:{"filterChanged":_vm.updateFilter}})],1)]),_vm._v(" "),_c('channel-results',{attrs:{"filter":_vm.filter},on:{"filterChanged":_vm.updateFilter,"myClearFilter":_vm.clearFilter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }